<template>
  <div class="table-container" style="padding: 0">

    <TableCommon title="基本信息" :show-custome="false">
      <div class="form-container" style="padding: 0">
        <el-form disabled inline size="mini" label-width="100px" :model="wlyClientPo">
          <el-row :gutter="24">
            <el-col :lg="8" :md="12">
              <el-form-item label="客户编码">
                <el-input v-model="wlyClientPo.PARTNER" disabled />
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12">
              <el-form-item label="客户名称">
                <el-input v-model="wlyClientPo.NAME_ORG1" disabled />
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12">
              <el-form-item label="客户类型">
                <el-select
                  v-model="wlyClientPo.ZZFLD000016"
                  placeholder="请选择"
                  type="select"
                  clearable
                  disabled
                >
                  <el-option
                    v-for="item in selectDataOptions['A0009']"
                    :key="item.value"
                    :value="item.value"
                    :label="item.name"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12">
              <el-form-item label="法人姓名">
                <el-input v-model="wlyClientPo.ZZFLD000018" placeholder="请输入" />
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12">
              <el-form-item label="法人电话">
                <el-input v-model="wlyClientPo.ZZFLD000019" placeholder="请输入" />
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12">
              <el-form-item label="营销管理编码">
                <el-input v-model="wlyClientPo.ZZFLD00001C" placeholder="请输入" />
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12">
              <el-form-item label="旧编码">
                <el-input v-model="wlyClientPo.ZZFLD000017" disabled />
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12">
              <el-form-item label="变更自客户">
                <el-input
                  v-model="wlyClientPo.ZZFLD00001D"
                  placeholder="请输入"
                  suffix-icon="el-icon-more"
                  @focus="openDialog($event, '客户选择', 1)"
                />
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12">
              <el-form-item label="变更客户描述">
                <el-input v-model="wlyClientPo.NAME_ORG2" placeholder="请输入" />
              </el-form-item>
            </el-col>

            <el-col :lg="8" :md="12">
              <el-form-item label="税号">
                <el-input v-model="TAX.TAXNUMXL" disabled />
              </el-form-item>
            </el-col>

            <el-col :lg="8" :md="12">
              <el-form-item label="发票类型">
                <el-select v-model="TAX.TAXTYPE">
                  <el-option
                    v-for="item in selectDataOptions['A0032']"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12">
              <el-form-item label="工商登记号">
                <el-input v-model="wlyClientPo.ZZFLD00001B" disabled />
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12">
              <el-form-item label="创建人">
                <el-input v-model="wlyClientPo.CRUSR_NAME" disabled />
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12">
              <el-form-item label="创建日期">
                <el-input v-model="wlyClientPo.CRDAT" disabled />
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12">
              <el-form-item label="渠道类型">
                <el-input v-model="wlyClientPo.ZZCUSTCHAL_TEXT" disabled />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :lg="8" :md="12">
              <el-form-item label="更改人">
                <el-input v-model="wlyClientPo.CHUSR_NAME" disabled />
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12">
              <el-form-item label="更改日期">
                <el-input v-model="wlyClientPo.CHDAT" disabled />
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12">
              <el-form-item label="终止协议">
                <el-checkbox v-model="wlyClientPo.ZZXY" disabled true-label="X" false-label="">是</el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :lg="8" :md="12">
              <el-form-item label="归档标识" class="crchive">
                <el-checkbox v-model="wlyClientPo.ZZFLD000026" label="X" disabled @change="radioChange">已归档</el-checkbox>
                <el-checkbox v-model="wlyClientPo.ZZFLD00009N" label="X" disabled>已停止未归档</el-checkbox>
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12">
              <el-form-item label="归档日期" class="crchive">
                <el-input v-model="wlyClientPo.ZZFLD000026_DATE" disabled size="mini" />
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12">
              <el-form-item label="归档备注" class="crchive">
                <el-input v-model="wlyClientPo.REMARK_GD" size="mini" />
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12">
              <el-form-item label="是否停用">
                <el-checkbox v-model="wlyClientPo.BLOCK" true-label="X" false-label="">是</el-checkbox>
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12">
              <el-form-item label="停用日期">
                <el-input v-model="wlyClientPo.BLOCK_DATE" disabled />
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12">
              <el-form-item label="停用备注">
                <el-input v-model="wlyClientPo.REMARK_BLK" />
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12">
              <el-form-item label="合作中">
                <el-checkbox v-model="wlyClientPo.COOPERATION" true-label="X" false-label="">是</el-checkbox>
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12">
              <el-form-item label="实际控制人">
                <el-input v-model="wlyClientPo.ZSJKZ_PL" />
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12">
              <el-form-item label="控制人电话">
                <el-input v-model="wlyClientPo.ZSJKZ_TL" />
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12">
              <el-form-item label="社会信用代码">
                <el-input v-model="wlyClientPo.ZZFLD00001A" disabled />
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12">
              <el-form-item label="业务去负责人">
                <el-input v-model="wlyClientPo.ZYWFZ_PL" />
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12">
              <el-form-item label="负责人电话">
                <el-input v-model="wlyClientPo.ZYWFZ_TL" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :lg="8" :md="12">
              <el-form-item label="备注">
                <el-input v-model="wlyClientPo.ZZFLD00008R" resize="none" type="textarea" rows="3" />
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12">
              <el-form-item label="备注1">
                <el-input v-model="wlyClientPo.ZZFLD00008S" resize="none" type="textarea" rows="3" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </TableCommon>

    <slot name="bank" />

    <!-- 客户变更历史 -->
    <TableCommon
      title="客户变更历史"
      :custome-config="() => vxeShowCustom('xTable2')"
    >
      <vxe-grid
        ref="xTable2"
        class="table-block"
        border
        :highlight-hover-row="true"
        resizable
        :show-overflow="true"
        max-height="260"
        align="center"
        size="mini"
        :empty-render="{name: 'NotData'}"
        :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
        :edit-config="{ trigger: 'manual', mode: 'row' }"
        :columns="gridOptions2.columns"
        :data="gridOptions2.data"
      />
    </TableCommon>
    <!-- 客户变更历史 -->
    <TableCommon
      title="客户类型变更记录"
      :custome-config="() => vxeShowCustom('xTable22')"
    >
      <vxe-grid
        ref="xTable22"
        class="table-block"
        border
        :highlight-hover-row="true"
        resizable
        :show-overflow="true"
        max-height="260"
        align="center"
        size="mini"
        :empty-render="{name: 'NotData'}"
        :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
        :edit-config="{ trigger: 'manual', mode: 'row' }"
        :columns="gridOptionsType.columns"
        :data="gridOptionsType.data"
      />
    </TableCommon>

    <!-- 营销单元 -->
    <TableCommon
      title="营销单元"
      :custome-config="() => vxeShowCustom('xTableSaleCenter')"
    >
      <vxe-grid
        ref="xTableSaleCenter"
        class="table-block"
        border
        :highlight-hover-row="true"
        resizable
        :show-overflow="true"
        height="auto"
        max-height="240"
        align="center"
        size="mini"
        :empty-render="{name: 'NotData'}"
        :toolbar-config="{ custom: false }"
        :edit-config="{ trigger: 'manual', mode: 'row' }"
        :columns="saleCenterGridOptions.columns"
        :data="saleCenterGridOptions.data"
      />
    </TableCommon>

    <!-- 地址信息 -->
    <TableCommon
      title="地址信息"
      :custome-config="() => vxeShowCustom('xTable3')"
    >
      <vxe-grid
        ref="xTable3"
        class="table-block"
        border
        :highlight-hover-row="true"
        resizable
        :show-overflow="true"
        height="auto"
        max-height="240"
        align="center"
        size="mini"
        :empty-render="{name: 'NotData'}"
        :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
        :edit-config="{ trigger: 'manual', mode: 'row' }"
        :columns="gridOptions3.columns"
        :data="gridOptions3.data"
      />
    </TableCommon>

    <!-- 可售产品 -->
    <TableCommon
      title="可售产品清单"
      :custome-config="() => vxeShowCustom('xTable')"
    >
      <vxe-grid
        ref="xTable"
        class="table-block"
        border
        :highlight-hover-row="true"
        resizable
        :show-overflow="true"
        height="auto"
        max-height="240"
        align="center"
        size="mini"
        :empty-render="{name: 'NotData'}"
        :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
        :edit-config="{ trigger: 'manual', mode: 'row' }"
        :columns="gridOptions.columns"
        :data="gridOptions.data"
      />
    </TableCommon>

    <slot name="relation" />
    <slot name="role" />
  </div>

</template>

<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { formatSapTime, formatSapDate} from '@/mixins/index'
export default {
  props: {
    clientData: {
      type: Object,
      defualt: () => null
    }
  },
  data() {
    return {
      wlyClientPo: {},
      TAX: {},
      HISTORY: [],
      gridOptionsApprove: {
        columns: [
          { field: 'channelManagerName', title: '渠道经理' },
          { field: 'baseManagerName', title: '基地经理' },
          { field: 'areaManagerName', title: '战区经理' },
          { field: 'corePlanPeopleName', title: '中心计划专员' },
          { field: 'affairPlanPeopleName', title: '公共事务部专员' }
        ],
        data: [
          {
            customerCode: '',
            id: '',
            channelManager: '',
            channelManagerName: '',
            baseManager: '',
            baseManagerName: '',
            areaManager: '',
            areaManagerName: '',
            corePlanPeople: '',
            corePlanPeopleName: '',
            affairPlanPeople: '',
            affairPlanPeopleName: ''
          }
        ]
      },
      // 营销单元
      saleCenterGridOptions: {
        columns: [
          { field: 'MC_SHORT', title: '营销单元' },
          { field: 'MC_SHORT_JD', title: '基地' }
        ],
        data: []
      },
      // 渠道信息
      channelGridOptions: {
        data: [],
        columns: [
          {
            field: 'stockType',
            title: '存货分类'
          },
          {
            field: 'saleChannelCode',
            title: '渠道类型'
          },
          {
            field: 'saleChannelManager',
            title: '渠道经理'
          }
        ]
      },
      // 可售产品
      gridOptions: {
        columns: [
          { field: 'ZZFLD00001Z', title: '产品信息', width: 300 },
          { field: 'ZZFLD000020', title: '产品描述' }
        ],
        data: []
      },
      gridOptionsType: {
        columns: [
          // { type: 'seq', field: 'seq', title: '序号', width: 50 },
          { field: 'CHANGE_NUMBER', title: '变更次数', width: 80 },
          { field: 'CHANGIN_DATE', title: '变更日期', width: 160, formatter: ({ cellValue }) => formatSapDate(cellValue) },
          { field: 'CHANGIN_TIME', title: '变更时间', width: 160, formatter: ({ cellValue }) => formatSapTime(cellValue) },
          { field: 'ZZFLD000016', title: '客户类型编码', width: 160 },
          { field: 'ZZFLD000016_TEXT', title: '客户类型描述' }
        ],
        data: []
      },
      // 客户变更历史
      gridOptions2: {
        columns: [
          { type: 'seq', field: 'seq', title: '序号', width: 50 },
          { field: 'C_DATUM1', title: '原始客户创建日期', width: 120 },
          { field: 'C_PAERTNER1', title: '原始客户编码', width: 120 },
          { field: 'C_PAERTNER1_D', title: '原始客户名称', width: 120 },
          { field: 'C_DATUM2', title: '第1次变更日期', width: 120, formatter: ({ cellValue }) => cellValue.replace('00000000', '') },
          { field: 'C_PAERTNER2', title: '第1次变更客户', width: 120 },
          { field: 'C_PAERTNER2_D', title: '第1次变更客户名称', width: 120 },
          { field: 'C_DATUM3', title: '第2次变更日期', width: 120, formatter: ({ cellValue }) => cellValue.replace('00000000', '') },
          { field: 'C_PAERTNER3', title: '第2次变更客户', width: 120 },
          { field: 'C_PAERTNER3_D', title: '第2次变更客户名称', width: 120 },
          { field: 'C_DATUM4', title: '第3次变更日期', width: 120, formatter: ({ cellValue }) => cellValue.replace('00000000', '') },
          { field: 'C_PAERTNER4', title: '第3次变更客户', width: 120 },
          { field: 'C_PAERTNER4_D', title: '第3次变更客户名称', width: 120 },
          { field: 'C_DATUM5', title: '第4次变更日期', width: 120, formatter: ({ cellValue }) => cellValue.replace('00000000', '') },
          { field: 'C_PAERTNER5', title: '第4次变更客户', width: 120 },
          { field: 'C_PAERTNER5_D', title: '第4次变更客户名称', width: 120 },
          { field: 'C_DATUM6', title: '第5次变更日期', width: 120, formatter: ({ cellValue }) => cellValue.replace('00000000', '') },
          { field: 'C_PAERTNER6', title: '第5次变更客户', width: 120 },
          { field: 'C_PAERTNER6_D', title: '第5次变更客户名称', width: 120 },
          { field: 'C_DATUM7', title: '第6次变更日期', width: 120, formatter: ({ cellValue }) => cellValue.replace('00000000', '') },
          { field: 'C_PAERTNER7', title: '第6次变更客户', width: 120 },
          { field: 'C_PAERTNER7_D', title: '第6次变更客户名称', width: 120 },
          { field: 'C_DATUM8', title: '第7次变更日期', width: 120, formatter: ({ cellValue }) => cellValue.replace('00000000', '') },
          { field: 'C_PAERTNER8', title: '第7次变更客户', width: 120 },
          { field: 'C_PAERTNER8_D', title: '第7次变更客户名称', width: 120 },
          { field: 'C_DATUM9', title: '第8次变更日期', width: 120, formatter: ({ cellValue }) => cellValue.replace('00000000', '') },
          { field: 'C_PAERTNER9', title: '第8次变更客户', width: 120 },
          { field: 'C_PAERTNER9_D', title: '第8次变更客户名称', width: 120 },
          { field: 'C_DATUM10', title: '第9次变更日期', width: 120, formatter: ({ cellValue }) => cellValue.replace('00000000', '') },
          { field: 'C_PAERTNER10', title: '第9次变更客户', width: 120 },
          { field: 'C_PAERTNER10_D', title: '第9次变更客户名称', width: 120 },
          { field: 'C_DATUM11', title: '第10次变更日期', width: 120, formatter: ({ cellValue }) => cellValue.replace('00000000', '') },
          { field: 'C_PAERTNER11', title: '第10次变更客户', width: 120 },
          { field: 'C_PAERTNER11_D', title: '第10次变更客户名称', width: 120 },
          { field: 'C_DATUM12', title: '第11次变更日期', width: 120, formatter: ({ cellValue }) => cellValue.replace('00000000', '') },
          { field: 'C_PAERTNER12', title: '第11次变更客户', width: 120 },
          { field: 'C_PAERTNER12_D', title: '第11次变更客户名称', width: 120 },
          { field: 'C_DATUM13', title: '第12次变更日期', width: 120, formatter: ({ cellValue }) => cellValue.replace('00000000', '') },
          { field: 'C_PAERTNER13', title: '第12次变更客户', width: 120 },
          { field: 'C_PAERTNER13_D', title: '第12次变更客户名称', width: 120 },
          { field: 'C_DATUM14', title: '第13次变更日期', width: 120, formatter: ({ cellValue }) => cellValue.replace('00000000', '') },
          { field: 'C_PAERTNER14', title: '第13次变更客户', width: 120 },
          { field: 'C_PAERTNER14_D', title: '第13次变更客户名称', width: 120 },
          { field: 'C_DATUM15', title: '第14次变更日期', width: 120, formatter: ({ cellValue }) => cellValue.replace('00000000', '') },
          { field: 'C_PAERTNER15', title: '第14次变更客户', width: 120 },
          { field: 'C_PAERTNER15_D', title: '第14次变更客户名称', width: 120 },
          { field: 'C_DATUM16', title: '第15次变更日期', width: 120, formatter: ({ cellValue }) => cellValue.replace('00000000', '') },
          { field: 'C_PAERTNER16', title: '第15次变更客户', width: 120 },
          { field: 'C_PAERTNER16_D', title: '第15次变更客户名称', width: 120 },
          { field: 'C_DATUM17', title: '第16次变更日期', width: 120, formatter: ({ cellValue }) => cellValue.replace('00000000', '') },
          { field: 'C_PAERTNER17', title: '第16次变更客户', width: 120 },
          { field: 'C_PAERTNER17_D', title: '第16次变更客户名称', width: 120 },
          { field: 'C_DATUM18', title: '第17次变更日期', width: 120, formatter: ({ cellValue }) => cellValue.replace('00000000', '') },
          { field: 'C_PAERTNER18', title: '第17次变更客户', width: 120 },
          { field: 'C_PAERTNER18_D', title: '第17次变更客户名称', width: 120 },
          { field: 'C_DATUM19', title: '第18次变更日期', width: 120, formatter: ({ cellValue }) => cellValue.replace('00000000', '') },
          { field: 'C_PAERTNER19', title: '第18次变更客户', width: 120 },
          { field: 'C_PAERTNER19_D', title: '第18次变更客户名称', width: 120 },
          { field: 'C_DATUM20', title: '第19次变更日期', width: 120, formatter: ({ cellValue }) => cellValue.replace('00000000', '') },
          { field: 'C_PAERTNER20', title: '第19次变更客户', width: 120 },
          { field: 'C_PAERTNER20_D', title: '第19次变更客户名称', width: 120 }
        ],
        data: []
      },
      // 地址信息
      gridOptions3: {
        columns: [
          { field: 'ADR_KIND_TEXT', title: '地址类型', width: 180 },
          { field: 'C_O_NAME', title: '联系人', width: 180 },
          { field: 'BUILDING', title: '身份证号', width: 180 },
          { field: 'TELNR_LONG', title: '电话', width: 180 },
          { field: 'TEL_NUMBER', title: '手机', width: 180 },
          { field: 'FAX_NUMBER', title: '传真', width: 180 },
          { field: 'BEZEI', title: '省', width: 180 },
          { field: 'CITY_NAME', title: '市', width: 180 },
          { field: 'STREET_NAME', title: '区', width: 180 },
          { field: 'STREET', title: '地址', width: 180 }
        ],
        data: [],
        delData: []
      },
      selectDataOptions: {
        province: [],
        orgList: []
      }
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.getInfo()
      this.getSelectDictDataOrigin('A0099')
      this.getSelectDictDataOrigin('A0019')
      this.getSelectDictDataOrigin('A0054')
      this.getSelectDictDataOrigin('A0032')
      this.getSelectDictDataOrigin('A0009')
    },
    // 获取详情
    async getInfo() {
      const DATA = this.clientData
      // this.gridOptionsApprove.data = [DATA.approve]
      // 客户基本信息
      this.wlyClientPo = DATA.INFO
      // 开票信息
      this.TAX = DATA.TAX
      // 营销中心
      this.saleCenterGridOptions.data = DATA.YXDY
      // 地址信息
      this.gridOptions3.data = DATA.ADDRESS
      // 变更信息
      this.gridOptions2.data = [DATA.HISTORY]
      // this.filterChangeInfo(DATA.HISTORY)
      this.HISTORY = DATA.HISTORY
      
      this.gridOptionsType.data = DATA.TYPE_HISTORY

      // 可售产品清单
      this.gridOptions.data = DATA.PRO

      // this.gridOptionsApprove.data[0].customerCode = this.wlyClientPo.PARTNER
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>

.common-title{
  margin-top: 50px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/client-manage/components/BaseInfoCheck.vue